
// FEE TYPES
export const GET_FEE_TYPES = "/fee-types";
export const ADD_NEW_FEE_TYPE = "/fee-types";
export const UPDATE_FEE_TYPE = "/fee-types";
export const DELETE_FEE_TYPE = "/fee-types";


